export default __webpack_public_path__ + "static/media/button-dont-example-1.81d11632.svg";